// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"b8a21158","470":"bf28cfed","661":"7e39157e","790":"24048d14"}[chunkId] + ".chunk.css";
};